<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <h1>{{ $t("blog.header") }}</h1>
      <div class="divide-y-2 divide-white py-18">
        <BlogHeaderSection v-if="headerBlog" :data="headerBlog"></BlogHeaderSection>
      </div>

      <BlogPosts :displayCategory="true" :latestBlogId="latestBlogId"></BlogPosts>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "@/stores/global";
const globalStore = useGlobalStore();
const site = () => globalStore.siteCurrentLocale;
defineI18nRoute({
  locales: ["en", "es"],
});
const headerBlog = ref({});

const { data: blogLists, pending, error: errorMessage, refresh } = await useBlogLatest(site);
if (import.meta.client && !blogLists.value?.data) await refresh();
headerBlog.value = blogLists.value?.data ?? null;
const latestBlogId = blogLists.value?.data?.id ?? 0;

useBlogMetaTitles(null, { alternates: true });
const breadcrumbs = getBreadcrumbs("blog");
</script>
